import { updateAllQueries } from 'api/urql/helpers/mutation';
import { query as getImportedDrafts } from 'components/pages/import/queries/getImportedDrafts';
import { query as paginatedDraftJobRequests } from 'components/pages/jobRequestDrafts/queries/paginatedDraftJobRequests';


export const deleteJobRequestDraft = (results, args, cache, info) => {
  // handlers go here
  updateAllQueries({
    fieldName: 'importedDrafts',
    query: getImportedDrafts,
  })(results, args, cache, info);

  updateAllQueries({
    fieldName: 'paginatedDraftJobRequests',
    query: paginatedDraftJobRequests,
  })(results, args, cache, info);
};

